<section class="rounded-lg bg-primary-50 p-4">
  <p-selectbutton
    [options]="[
      {
        label: 'cruise.meanValues' | transloco,
        value: false,
      },
      {
        label: 'cruise.advancedOptions' | transloco,
        value: true,
      },
    ]"
    [(ngModel)]="showAdvancedOptions"
    [ngModelOptions]="{ standalone: true }"
    (onChange)="onModeChange()"
    aria-label="Switch between simple and advanced options"
    class="mb-4"
  />
  <form
    [formGroup]="transportFormService.transportForm"
    class="flex flex-col gap-4"
  >
    <!-- subtype -->
    <div class="flex flex-1 flex-col">
      <label for="subtype" class="text-sm font-semibold text-primary-500"
        >{{
          "calculator.placeholder.cruiseSubtype" | transloco
        }}
        *<app-tooltip-icon
          position="left"
          [message]="'calculator.cruiseSubtypeTooltip' | transloco"
      /></label>
      <p-select
        formControlName="subtype"
        [options]="options"
        [placeholder]="'calculator.placeholder.cruiseSubtype' | transloco"
        class="flex-1"
      />
    </div>

    <!-- days -->
    <div class="flex flex-1 flex-col">
      <label for="durationDays" class="text-sm font-semibold text-primary-500"
        >{{ "calculator.placeholder.durationDays" | transloco }} *</label
      >
      <p-inputNumber
        formControlName="duration"
        [placeholder]="'calculator.placeholder.durationDays' | transloco"
        class="flex-1"
        [minFractionDigits]="0"
        [maxFractionDigits]="20"
        id="durationDays"
      />
    </div>

    @if (showAdvancedOptions) {
      <!-- days without travel -->
      <div class="flex flex-1 flex-col">
        <label
          for="daysWithoutTravel"
          class="text-sm font-semibold text-primary-500"
          >{{ "calculator.placeholder.daysWithoutTravel" | transloco }}</label
        >
        <p-inputNumber
          formControlName="daysWithoutTravel"
          [placeholder]="'calculator.placeholder.daysWithoutTravel' | transloco"
          class="flex-1"
          [minFractionDigits]="0"
          [maxFractionDigits]="20"
        />
      </div>

      <!-- distance per day -->
      <div class="flex flex-1 flex-col">
        <label for="subtype" class="text-sm font-semibold text-primary-500"
          >{{ "calculator.placeholder.distancePerDay" | transloco
          }}<app-tooltip-icon
            position="left"
            [message]="'calculator.distancePerDayTooltip' | transloco"
        /></label>
        <p-inputNumber
          formControlName="distancePerDay"
          [placeholder]="'calculator.placeholder.distancePerDay' | transloco"
          class="flex-1"
          [minFractionDigits]="0"
          [maxFractionDigits]="20"
        />
      </div>
    }
  </form>
</section>
